import { apiFetch } from "./apiClient";

export async function getLogs({ device_id, start, end, limit, offset }) {
  const params = new URLSearchParams();

  // device_id can be an array or a single value
  if (Array.isArray(device_id)) {
    device_id.forEach((id) => params.append("device_id", id));
  } else {
    params.append("device_id", device_id);
  }

  params.append("start", start);
  params.append("end", end);

  if (limit !== undefined) params.append("limit", limit);
  if (offset !== undefined) params.append("offset", offset);

  const queryString = params.toString();
  const response = await apiFetch(`/api/v1/get-logs?${queryString}`);

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.error || "Failed to fetch logs");
  }

  return response.json();
}
